import { OverflowTooltip } from '@/components/common/overflow-tooltip';
import type { TooltipAppearance } from '@/components/common/tooltip';

import styles from './cells.module.scss';

export function textCell(value: string, appearance?: TooltipAppearance) {
  return (
    <OverflowTooltip title={value} appearance={appearance}>
      <span className={styles.text}>{value}</span>
    </OverflowTooltip>
  );
}
